import { createStyles, makeStyles, Typography } from "@material-ui/core"
import { colors } from "../../utils/theme"
import Logo from "../atoms/Logo"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) =>
  createStyles({
    dashboard: {
      width: "400px",
      padding: "25px",
      borderColor: "#C8CDDB",
      borderStyle: "solid",
      borderWidth: "1px",
      borderRadius: "4px",
      backgroundColor: colors.neutral.white,
      height: "570px",
    },
    logo: {
      position: "absolute",
      top: theme.spacing(6),
      left: theme.spacing(6),
    },
    subtitle: {
      fontWeight: 400,
      color: colors.neutral.denim,
      marginBottom: theme.spacing(4),
    },
    marginLink: {
      margin: theme.spacing(0.5),
    },
    marginLeft: {
      marginLeft: theme.spacing(11),
    },
  })
)

const DashboardAccess = () => {
  const classes = useStyles()

  return (
    <>
      <BaseTemplate>
        <div className={classes.marginLeft}>
          <Logo className={classes.logo} />
          <div className={classes.dashboard}>
            <div title="Access to the Patient Dashboard">
              <Typography variant="h2">
                Access to the Patient Dashboard
              </Typography>
              <Typography variant="body1" className={classes.subtitle}>
                Here are some common reasons you may not have access to the
                dashboard:
              </Typography>
              <div>
                <Typography variant="h4">EHR User</Typography>
              </div>
              <div className={classes.subtitle}>
                <ul>
                  <li>
                    Your organization has opted for a limited release, which
                    restricts access to EHR users with an established Vira
                    account.
                  </li>
                </ul>
              </div>
              <div>
                <Typography variant="h4">Patient Account</Typography>
              </div>
              <div className={classes.subtitle}>
                <ul>
                  <li>
                    The patient’s order has been placed, but their account has
                    not yet been created.
                  </li>
                  <li>
                    Data sharing permissions for the patient account have been
                    revoked by either the patient or the ordering provider.
                  </li>
                  <ul className={classes.marginLink}>
                    <li>
                      To restore data sharing, please contact the patient to
                      reconnect permissions.
                    </li>
                    <li>
                      In an upcoming release, you will be able to access data
                      uploaded during the active data-sharing period.
                    </li>
                  </ul>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </BaseTemplate>
    </>
  )
}

export default DashboardAccess
